import React, { useState, useEffect } from 'react';
import './HomePage.css';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Legend } from 'recharts';
import { AiFillHome } from 'react-icons/ai';
import { MdRestaurantMenu } from 'react-icons/md';
import { FaMoneyBillWave, FaUserFriends, FaGift } from 'react-icons/fa';
import { GiKnifeFork } from 'react-icons/gi';

const navItems = [
  'Home',
  'Product',
  'Sales',
  'Members',
  'Promotion',
  'Restaurant',
];

const navIcons = {
  Home: <AiFillHome className="nav-icon" />,
  Product: <MdRestaurantMenu className="nav-icon" />,
  Sales: <FaMoneyBillWave className="nav-icon" />,
  Members: <FaUserFriends className="nav-icon" />,
  Promotion: <FaGift className="nav-icon" />,
  Restaurant: <GiKnifeFork className="nav-icon" />,
};

// 不同时间段的数据 - 重新设计逻辑
const timeRangeData = {
  '2024-06-01_2024-06-30': {
    totalRevenue: {
      value: 128000,
      change: 0.12,
    },
    orders: {
      value: 3200,
      change: -0.05,
    },
    bestsellers: [
      { name: 'Spicy Hot Pot', sold: 520, amount: 15600, image: '/images/spicy-hot-pot.jpg' },
      { name: 'Kung Pao Chicken', sold: 410, amount: 12300, image: '/images/kung-pao-chicken.jpg' },
      { name: 'Fish Fragrant Shredded Pork', sold: 390, amount: 11700, image: '/images/fish-fragrant-pork.jpg' },
      { name: 'Beef Noodle Soup', sold: 350, amount: 10500, image: '/images/beef-noodle-soup.jpg' },
    ],
    categorySales: [
      { name: 'Main Dishes', value: 40000 },
      { name: 'Snacks', value: 25000 },
      { name: 'Beverages', value: 18000 },
      { name: 'Desserts', value: 15000 },
      { name: 'Others', value: 30000 },
    ],
    salesAnalytics: [
      { month: 'Jan', sales: 8000 },
      { month: 'Feb', sales: 12000 },
      { month: 'Mar', sales: 15000 },
      { month: 'Apr', sales: 18000 },
      { month: 'May', sales: 22000 },
      { month: 'Jun', sales: 28000 },
    ],
    reservationAnalytics: [
      { month: 'Jan', reservations: 150 },
      { month: 'Feb', reservations: 180 },
      { month: 'Mar', reservations: 220 },
      { month: 'Apr', reservations: 250 },
      { month: 'May', reservations: 280 },
      { month: 'Jun', reservations: 320 },
    ],
  },
  '2024-06-01_2024-06-15': {
    totalRevenue: {
      value: 65000,
      change: 0.08,
    },
    orders: {
      value: 1650,
      change: 0.02,
    },
    bestsellers: [
      { name: 'Kung Pao Chicken', sold: 280, amount: 8400, image: '/images/kung-pao-chicken.jpg' },
      { name: 'Spicy Hot Pot', sold: 260, amount: 7800, image: '/images/spicy-hot-pot.jpg' },
      { name: 'Fish Fragrant Shredded Pork', sold: 240, amount: 7200, image: '/images/fish-fragrant-pork.jpg' },
      { name: 'Beef Noodle Soup', sold: 200, amount: 6000, image: '/images/beef-noodle-soup.jpg' },
    ],
    categorySales: [
      { name: 'Main Dishes', value: 20000 },
      { name: 'Snacks', value: 12500 },
      { name: 'Beverages', value: 9000 },
      { name: 'Desserts', value: 7500 },
      { name: 'Others', value: 15000 },
    ],
    salesAnalytics: [
      { month: 'Jan', sales: 8000 },
      { month: 'Feb', sales: 12000 },
      { month: 'Mar', sales: 15000 },
      { month: 'Apr', sales: 18000 },
      { month: 'May', sales: 22000 },
      { month: 'Jun', sales: 14000 },
    ],
    reservationAnalytics: [
      { month: 'Jan', reservations: 150 },
      { month: 'Feb', reservations: 180 },
      { month: 'Mar', reservations: 220 },
      { month: 'Apr', reservations: 250 },
      { month: 'May', reservations: 280 },
      { month: 'Jun', reservations: 160 },
    ],
  },
  '2024-06-16_2024-06-30': {
    totalRevenue: {
      value: 63000,
      change: 0.15,
    },
    orders: {
      value: 1550,
      change: -0.12,
    },
    bestsellers: [
      { name: 'Spicy Hot Pot', sold: 260, amount: 7800, image: '/images/spicy-hot-pot.jpg' },
      { name: 'Kung Pao Chicken', sold: 130, amount: 3900, image: '/images/kung-pao-chicken.jpg' },
      { name: 'Fish Fragrant Shredded Pork', sold: 150, amount: 4500, image: '/images/fish-fragrant-pork.jpg' },
      { name: 'Beef Noodle Soup', sold: 150, amount: 4500, image: '/images/beef-noodle-soup.jpg' },
    ],
    categorySales: [
      { name: 'Main Dishes', value: 20000 },
      { name: 'Snacks', value: 12500 },
      { name: 'Beverages', value: 9000 },
      { name: 'Desserts', value: 7500 },
      { name: 'Others', value: 15000 },
    ],
    salesAnalytics: [
      { month: 'Jan', sales: 8000 },
      { month: 'Feb', sales: 12000 },
      { month: 'Mar', sales: 15000 },
      { month: 'Apr', sales: 18000 },
      { month: 'May', sales: 22000 },
      { month: 'Jun', sales: 14000 },
    ],
    reservationAnalytics: [
      { month: 'Jan', reservations: 150 },
      { month: 'Feb', reservations: 180 },
      { month: 'Mar', reservations: 220 },
      { month: 'Apr', reservations: 250 },
      { month: 'May', reservations: 280 },
      { month: 'Jun', reservations: 160 },
    ],
  },
  '2024-05-01_2024-05-31': {
    totalRevenue: {
      value: 115000,
      change: 0.08,
    },
    orders: {
      value: 2900,
      change: 0.03,
    },
    bestsellers: [
      { name: 'Kung Pao Chicken', sold: 480, amount: 14400, image: '/images/kung-pao-chicken.jpg' },
      { name: 'Fish Fragrant Shredded Pork', sold: 420, amount: 12600, image: '/images/fish-fragrant-pork.jpg' },
      { name: 'Spicy Hot Pot', sold: 380, amount: 11400, image: '/images/spicy-hot-pot.jpg' },
      { name: 'Beef Noodle Soup', sold: 320, amount: 9600, image: '/images/beef-noodle-soup.jpg' },
    ],
    categorySales: [
      { name: 'Main Dishes', value: 35000 },
      { name: 'Snacks', value: 22000 },
      { name: 'Beverages', value: 16000 },
      { name: 'Desserts', value: 12000 },
      { name: 'Others', value: 30000 },
    ],
    salesAnalytics: [
      { month: 'Jan', sales: 7000 },
      { month: 'Feb', sales: 11000 },
      { month: 'Mar', sales: 14000 },
      { month: 'Apr', sales: 17000 },
      { month: 'May', sales: 20000 },
    ],
    reservationAnalytics: [
      { month: 'Jan', reservations: 120 },
      { month: 'Feb', reservations: 150 },
      { month: 'Mar', reservations: 180 },
      { month: 'Apr', reservations: 200 },
      { month: 'May', reservations: 220 },
    ],
  },
  '2024-04-01_2024-04-30': {
    totalRevenue: {
      value: 98000,
      change: -0.02,
    },
    orders: {
      value: 2500,
      change: -0.08,
    },
    bestsellers: [
      { name: 'Fish Fragrant Shredded Pork', sold: 450, amount: 13500, image: '/images/fish-fragrant-pork.jpg' },
      { name: 'Kung Pao Chicken', sold: 400, amount: 12000, image: '/images/kung-pao-chicken.jpg' },
      { name: 'Beef Noodle Soup', sold: 350, amount: 10500, image: '/images/beef-noodle-soup.jpg' },
      { name: 'Spicy Hot Pot', sold: 300, amount: 9000, image: '/images/spicy-hot-pot.jpg' },
    ],
    categorySales: [
      { name: 'Main Dishes', value: 30000 },
      { name: 'Snacks', value: 20000 },
      { name: 'Beverages', value: 15000 },
      { name: 'Desserts', value: 10000 },
      { name: 'Others', value: 23000 },
    ],
    salesAnalytics: [
      { month: 'Jan', sales: 6000 },
      { month: 'Feb', sales: 10000 },
      { month: 'Mar', sales: 13000 },
      { month: 'Apr', sales: 16000 },
    ],
    reservationAnalytics: [
      { month: 'Jan', reservations: 100 },
      { month: 'Feb', reservations: 120 },
      { month: 'Mar', reservations: 140 },
      { month: 'Apr', reservations: 160 },
    ],
  },
  '2024-04-01_2024-06-30': {
    totalRevenue: {
      value: 341000,
      change: 0.25,
    },
    orders: {
      value: 8600,
      change: 0.18,
    },
    bestsellers: [
      { name: 'Kung Pao Chicken', sold: 1290, amount: 38700, image: '/images/kung-pao-chicken.jpg' },
      { name: 'Fish Fragrant Shredded Pork', sold: 1260, amount: 37800, image: '/images/fish-fragrant-pork.jpg' },
      { name: 'Spicy Hot Pot', sold: 1200, amount: 36000, image: '/images/spicy-hot-pot.jpg' },
      { name: 'Beef Noodle Soup', sold: 1020, amount: 30600, image: '/images/beef-noodle-soup.jpg' },
    ],
    categorySales: [
      { name: 'Main Dishes', value: 105000 },
      { name: 'Snacks', value: 67000 },
      { name: 'Beverages', value: 49000 },
      { name: 'Desserts', value: 37000 },
      { name: 'Others', value: 83000 },
    ],
    salesAnalytics: [
      { month: 'Jan', sales: 21000 },
      { month: 'Feb', sales: 33000 },
      { month: 'Mar', sales: 42000 },
      { month: 'Apr', sales: 51000 },
      { month: 'May', sales: 62000 },
      { month: 'Jun', sales: 72000 },
    ],
    reservationAnalytics: [
      { month: 'Jan', reservations: 370 },
      { month: 'Feb', sales: 450 },
      { month: 'Mar', reservations: 580 },
      { month: 'Apr', reservations: 660 },
      { month: 'May', reservations: 780 },
      { month: 'Jun', reservations: 640 },
    ],
  },
};

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#A28BFE'];

const timeLengthOptions = ['6 months', '12 months', '18 months', '24 months'];

// 根据时间长度生成对应的数据点
const generateAnalyticsData = (timeLength, baseData) => {
  const monthCount = parseInt(timeLength.split(' ')[0]);
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  
  // 生成销售数据
  const salesData = [];
  const reservationData = [];
  
  // 使用种子确保相同时间长度生成相同数据
  const seed = monthCount * 1000;
  
  for (let i = 0; i < monthCount; i++) {
    const monthIndex = i % 12;
    const monthName = months[monthIndex];
    
    // 生成合理的销售数据（递增趋势，使用种子确保一致性）
    const randomFactor = Math.sin(seed + i) * 0.5 + 0.5; // 0-1之间的值
    const baseSales = 8000 + (i * 1500) + Math.floor(randomFactor * 4000);
    salesData.push({
      month: monthName,
      sales: baseSales
    });
    
    // 生成合理的预定数据（递增趋势）
    const reservationRandomFactor = Math.cos(seed + i) * 0.5 + 0.5;
    const baseReservations = 150 + (i * 25) + Math.floor(reservationRandomFactor * 60);
    reservationData.push({
      month: monthName,
      reservations: baseReservations
    });
  }
  
  return {
    salesAnalytics: salesData,
    reservationAnalytics: reservationData
  };
};

function HomePage({ onNavigate }) {
  const [startDate, setStartDate] = useState('2024-06-01');
  const [endDate, setEndDate] = useState('2024-06-30');
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [analyticsType, setAnalyticsType] = useState('sales'); // 'sales' or 'reservation'
  const [timeLength, setTimeLength] = useState('12 months');
  const [dashboardData, setDashboardData] = useState(null);

  const handleNavClick = (item) => {
    if (onNavigate) {
      onNavigate(item);
    }
  };

  // 根据日期范围和时间长度获取数据
  const getDataForDateRange = () => {
    const dateKey = `${startDate}_${endDate}`;
    const baseData = timeRangeData[dateKey] || timeRangeData['2024-06-01_2024-06-30'];
    
    // 根据时间长度生成动态数据
    const dynamicAnalytics = generateAnalyticsData(timeLength, baseData);
    
    return {
      ...baseData,
      salesAnalytics: dynamicAnalytics.salesAnalytics,
      reservationAnalytics: dynamicAnalytics.reservationAnalytics
    };
  };

  // 当日期或时间长度改变时更新数据
  useEffect(() => {
    const data = getDataForDateRange();
    setDashboardData(data);
  }, [startDate, endDate, timeLength]);

  const formatDateRange = () => {
    return `${startDate} - ${endDate}`;
  };

  // 如果数据还没准备好，显示加载状态
  if (!dashboardData) {
    return <div>Loading...</div>;
  }

  return (
    <div className="homepage-container">
      <nav className="sidebar">
        <div className="sidebar-title">Restaurant Management</div>
        <ul>
          {navItems.map(item => (
            <li 
              key={item} 
              className={item === 'Home' ? 'active' : ''}
              onClick={() => handleNavClick(item)}
            >
              <span className="nav-icon">{navIcons[item]}</span> {item}
            </li>
          ))}
        </ul>
      </nav>
      <main className="dashboard">
        <div className="dashboard-header">
          <h1>Dashboard</h1>
          <div className="date-picker-container">
            <button 
              className="date-picker-btn"
              onClick={() => setShowDatePicker(!showDatePicker)}
            >
              📅 Date Range
            </button>
            {showDatePicker && (
              <div className="date-picker-dropdown">
                <div className="date-input-group">
                  <label>Start Date:</label>
                  <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                </div>
                <div className="date-input-group">
                  <label>End Date:</label>
                  <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </div>
                <button 
                  className="apply-date-btn"
                  onClick={() => setShowDatePicker(false)}
                >
                  Apply
                </button>
              </div>
            )}
          </div>
        </div>
        <div className="dashboard-cards">
          <div className="dashboard-card">
            <div className="card-title">Total Revenue</div>
            <div className="card-value">¥{dashboardData.totalRevenue.value.toLocaleString()}</div>
            <div className="card-desc">{formatDateRange()} &nbsp; <span className={dashboardData.totalRevenue.change >= 0 ? 'up' : 'down'}>{dashboardData.totalRevenue.change >= 0 ? '↑' : '↓'}{Math.abs(dashboardData.totalRevenue.change * 100)}%</span> vs previous period</div>
          </div>
          <div className="dashboard-card">
            <div className="card-title">Orders</div>
            <div className="card-value">{dashboardData.orders.value.toLocaleString()}</div>
            <div className="card-desc">{formatDateRange()} &nbsp; <span className={dashboardData.orders.change >= 0 ? 'up' : 'down'}>{dashboardData.orders.change >= 0 ? '↑' : '↓'}{Math.abs(dashboardData.orders.change * 100)}%</span> vs previous period</div>
          </div>
        </div>
        <div className="dashboard-bestsellers">
          <h2>Bestsellers Top 4</h2>
          <table>
            <thead>
              <tr>
                <th>Dish</th>
                <th>Sold</th>
                <th>Total Amount</th>
              </tr>
            </thead>
            <tbody>
              {dashboardData.bestsellers.map(item => (
                <tr key={item.name}>
                  <td>
                    <div className="dish-item">
                      <img 
                        src={item.image} 
                        alt={item.name}
                        className="dish-image"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextSibling.style.display = 'inline';
                        }}
                      />
                      <span className="dish-fallback" style={{display: 'none'}}>🍽️</span>
                      <span className="dish-name">{item.name}</span>
                    </div>
                  </td>
                  <td>{item.sold}</td>
                  <td>¥{item.amount.toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="dashboard-charts">
          <div className="chart-block">
            <h2>Sales Across Categories (Pie Chart)</h2>
            <div className="chart-container">
              <ResponsiveContainer width="60%" height={250}>
                <PieChart>
                  <Pie data={dashboardData.categorySales} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={80} label>
                    {dashboardData.categorySales.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                  </Pie>
                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
              <div className="chart-legend">
                <h3>Category Legend:</h3>
                {dashboardData.categorySales.map((entry, index) => (
                  <div key={entry.name} className="legend-item">
                    <span 
                      className="legend-color" 
                      style={{ backgroundColor: COLORS[index % COLORS.length] }}
                    ></span>
                    <span className="legend-text">{entry.name}: ¥{entry.value.toLocaleString()}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="chart-block">
            <div className="analytics-header">
              <h2>Analytics</h2>
              <div className="analytics-controls">
                <div className="toggle-buttons">
                  <button 
                    className={`toggle-btn ${analyticsType === 'sales' ? 'active' : ''}`}
                    onClick={() => setAnalyticsType('sales')}
                  >
                    Sales
                  </button>
                  <button 
                    className={`toggle-btn ${analyticsType === 'reservation' ? 'active' : ''}`}
                    onClick={() => setAnalyticsType('reservation')}
                  >
                    Reservation
                  </button>
                </div>
                <select 
                  className="time-length-select"
                  value={timeLength}
                  onChange={(e) => setTimeLength(e.target.value)}
                >
                  {timeLengthOptions.map(option => (
                    <option key={option} value={option}>{option}</option>
                  ))}
                </select>
              </div>
            </div>
            <ResponsiveContainer width="100%" height={250}>
              <LineChart data={analyticsType === 'sales' ? dashboardData.salesAnalytics : dashboardData.reservationAnalytics}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="month" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line 
                  type="monotone" 
                  dataKey={analyticsType === 'sales' ? 'sales' : 'reservations'} 
                  stroke="#8884d8" 
                  activeDot={{ r: 8 }}
                  name={analyticsType === 'sales' ? 'Sales (¥)' : 'Reservations (count)'}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </main>
    </div>
  );
}

export default HomePage; 